import { useState, useEffect } from 'react';
import { categories } from '@/mocks/categories';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';

export default function CategoriesPage() {
  const [activeCategory, setActiveCategory] = useState(categories[0].id);
  const currentCategory = categories.find((c) => c.id === activeCategory) || categories[0];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const collectionJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: '欧美精品 - 精选分类',
    description: '探索欧美精品三大核心品类：时尚服饰、护肤美妆、生活家居。每一件均经严格品控，品质有保障。',
    url: 'https://www.oumeijingpin.com/categories',
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title="精选分类｜欧美精品"
        description="探索欧美精品三大核心品类：时尚服饰、护肤美妆、生活家居。每一件欧美精品均经严格品控，品质有保障，为您精选全球顶尖品牌好物。"
        keywords="欧美精品分类,欧美精品服饰,欧美精品护肤品,欧美精品家居,欧美精品品牌推荐"
        canonicalUrl="https://www.oumeijingpin.com/categories"
        jsonLd={collectionJsonLd}
      />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '精选分类' }]} />

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <h1 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 text-center mb-3">
            精选分类
          </h1>
          <p className="text-sm text-foreground-500 text-center mb-8 max-w-xl mx-auto">
            三大核心品类，每一件欧美精品均经严格品控，品质有保障
          </p>

          <div className="flex items-center justify-center gap-2 mb-10">
            <div className="inline-flex bg-background-100 rounded-full p-1">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    activeCategory === cat.id
                      ? 'bg-primary-500 text-white'
                      : 'text-foreground-600 hover:text-foreground-900'
                  }`}
                >
                  {cat.name}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
            {currentCategory.products.map((product) => (
              <div
                key={product.id}
                className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 group cursor-pointer"
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-4">
                  <p className="text-xs text-primary-600 font-medium mb-1">{product.brand}</p>
                  <h3 className="font-heading text-sm font-medium text-foreground-900 mb-1.5 line-clamp-1">
                    {product.name}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{product.description}</p>
                  <div className="flex items-center gap-2">
                    <span className="text-base font-semibold text-accent-600">{product.price}</span>
                    {product.originalPrice && (
                      <span className="text-xs text-foreground-400 line-through">{product.originalPrice}</span>
                    )}
                  </div>
                  <div className="mt-2 flex flex-wrap gap-1">
                    {product.tags.map((tag) => (
                      <span key={tag} className="text-[10px] px-2 py-0.5 rounded-full bg-background-100 text-foreground-500">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}